import { Component } from '@angular/core';

import {App, NavController, ModalController, ViewController, NavParams} from 'ionic-angular';


@Component({
    template: `
    <ion-list>
        <button ion-item [hidden]="!locate" (click)="close('locate')">Comment s'y rendre ?</button>
        <button ion-item [hidden]="!video" (click)="close('video')">Ajouter une vidéo</button>
        <button ion-item [hidden]="!cancel" (click)="close('cancel')">Annuler la candidature</button>
        <button ion-item [hidden]="!chat" (click)="close('chat')">Contact l'entreprise</button>
        <button ion-item [hidden]="!support" (click)="close('support')">Support Novaterim</button>
    </ion-list>
  `
})
export class MissionCandidateDetailPopover {

    public video:boolean = false;
    public cancel:boolean = false;
    public support:boolean = true;
    public locate:boolean = true;

    constructor(
        public viewCtrl: ViewController,
        public navCtrl: NavController,
        public navParams: NavParams,
        public app: App,
        public modalCtrl: ModalController
    ) {
        if(this.navParams.data.video)this.video=true;
        if(this.navParams.data.cancel)this.cancel=true;
        if(this.navParams.data.locate)this.locate=true;
        if(this.navParams.data.support)this.support=true;
    }
    close(action) {
        this.viewCtrl.dismiss(action);
    }
}


// WEBPACK FOOTER //
// ./src/pages/missions/missions-candidate/missions-candidate-detail/popover.ts